import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';
import { updateManifestLink } from './utils/manifestGenerator';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// PWA functionality - controlled by environment variable
const isPWAEnabled = process.env.REACT_APP_ENABLE_PWA === 'true';

// Update manifest based on PWA configuration
updateManifestLink(isPWAEnabled);

// Register service worker for PWA functionality (only if enabled)
if (isPWAEnabled && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
        
        // Check for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New content is available, notify user
                console.log('New content is available; please refresh.');
                
                // You can show a notification to the user here
                if (window.confirm('New version available! Refresh to update?')) {
                  window.location.reload();
                }
              }
            });
          }
        });
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
} else if (!isPWAEnabled) {
  console.log('PWA functionality disabled via environment variable');
}

// Note: PWA install prompt handling is now managed by the React SimplePWAInstall component
// when REACT_APP_ENABLE_PWA is true. This avoids conflicts between vanilla JS and React implementations.

// Handle successful app installation
if (isPWAEnabled) {
  window.addEventListener('appinstalled', (evt) => {
    console.log('PWA was installed successfully');
    
    // Track installation event (you can add analytics here)
    console.log('App installation completed');
  });
}

// Handle online/offline status with debouncing to reduce false positives
let offlineTimeout;

window.addEventListener('online', () => {
  console.log('App is online');
  // Clear any pending offline notification
  if (offlineTimeout) {
    clearTimeout(offlineTimeout);
    offlineTimeout = null;
  }
  // Show online notification immediately
  showNetworkStatus('online');
});

window.addEventListener('offline', () => {
  console.log('App is offline');
  // Delay showing offline status to avoid false positives from brief network hiccups
  offlineTimeout = setTimeout(() => {
    showNetworkStatus('offline');
    offlineTimeout = null;
  }, 2000); // Wait 2 seconds before showing offline status
});

// Function to show network status
function showNetworkStatus(status) {
  // Remove existing status indicator
  const existingIndicator = document.getElementById('network-status');
  if (existingIndicator) {
    existingIndicator.remove();
  }
  
  // Create new status indicator
  const statusIndicator = document.createElement('div');
  statusIndicator.id = 'network-status';
  statusIndicator.textContent = status === 'online' ? 'Back Online' : 'Offline Mode';
  statusIndicator.style.cssText = `
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: ${status === 'online' ? '#4caf50' : '#ff9800'};
    color: white;
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: bold;
    z-index: 1001;
    transition: all 0.3s ease;
  `;
  
  document.body.appendChild(statusIndicator);
  
  // Auto-remove after 3 seconds
  setTimeout(() => {
    if (document.getElementById('network-status')) {
      statusIndicator.style.opacity = '0';
      setTimeout(() => statusIndicator.remove(), 300);
    }
  }, 3000);
}
